import React from 'react'

const Invoice = () => {
  return (
    <div style={{ marginLeft:"10%" ,height:"100vh"}}>
    <img
      src="https://blog-cdn.everhour.com/assets/images/new-design/screens/integrations/github-primary.webp"
      alt="" />         
</div>    
  )
}

export default Invoice
